import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.04 16" width="1em" height="1em" {...props}><g fill="#474747"><path d="M0 10.988h5.016v4.972H0zm5.024-9.96h5.016V6H5.024zm6 10h5.016V16h-5.016z" style={{
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#bebebe" overflow="visible" opacity={0.35} /><path d="M3.542 7.04c.829 0 1.496.668 1.496 1.497v.005c0 .829-.667 1.496-1.496 1.496a1.493 1.493 0 01-1.496-1.496v-.005c0-.829.667-1.496 1.496-1.496zm4 0c.829 0 1.496.668 1.496 1.497v.005c0 .829-.667 1.496-1.496 1.496a1.493 1.493 0 01-1.496-1.496v-.005c0-.829.667-1.496 1.496-1.496z" style={{
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" display="block" overflow="visible" /><path d="M7.542 7.04c.829 0 1.496.668 1.496 1.497v.005c0 .829-.667 1.496-1.496 1.496a1.493 1.493 0 01-1.496-1.496v-.005c0-.829.667-1.496 1.496-1.496zm4 0c.829 0 1.496.668 1.496 1.497v.005c0 .829-.667 1.496-1.496 1.496a1.493 1.493 0 01-1.496-1.496v-.005c0-.829.667-1.496 1.496-1.496z" style={{
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" display="block" overflow="visible" /></g></svg>;
}

export default SvgComponent;